<h3>Client Chores</h3>

<form novalidate>
  <div class="container-fluid p-2 border rounded bg-light mb-2">
    <div class="row">

      <div class="col-11">
        <app-client-chore-filters
          [filters]="filters"
          [statuses]="filterableStatuses"
          [excludedNames]="excludedChoreNames"
          (filterChange)="onFilterChange()" />
      </div>

      <div class="col-1 text-end">
        <a routerLink="/capture-admin/tools/client-chore/create" class="btn btn-primary">New</a>
      </div>

    </div>
  </div>
</form>

@if (!loading) {
  <div>
    <section>
      <div class="row">
        <div class="col-12">
          <app-pagination-header
            [label]="'client chores'"
            [paging]="paging"
            (pageSizeChange)="onPageSizeChange($event)"
            [includeResetFiltersButton]="true"
            (resetFiltersClick)="onClearClick()" />
          <app-client-chore-list
            [clientChores]="clientChores"
            [canManageChores]="true" />
          <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
        </div>
      </div>
    </section>
  </div>
} @else {
  <mat-spinner />
}
